// extracted by mini-css-extract-plugin
module.exports = {"shell":"request_shell__2wsGT"};